// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"cf10dbc2","488":"b5bc9612"}[chunkId] + ".chunk.js";
};